import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-recurring-class-action-confirmation',
    templateUrl: './recurring-class-action-confirmation.component.html',
    styleUrls: ['./recurring-class-action-confirmation.component.scss'],
    standalone: false
})
export class RecurringClassActionConfirmationComponent implements OnInit {
    close: Function;

    public includingFollowingModeForm: UntypedFormGroup;
    public fields: string;
    // Input parameters
    public event: { isRecurring: boolean; changedFields: string[] };
    public warningBar: boolean;
    public bodyText: string;
    public headerText: string;
    public confirmed: (boolean) => void;
    // End of input parameters

    constructor(private formBuilder: UntypedFormBuilder, private translateService: TranslateService) {}

    ngOnInit() {
        this.includingFollowingModeForm = this.formBuilder.group({
            actionMode: [null, [Validators.required]]
        });

        this.translateChangedFields();
    }

    private translateChangedFields() {
        if (this.event.changedFields) {
            this.fields = this.event.changedFields
                .map(field => this.translateService.instant('GroupClassFields.' + field))
                .join(', ');
        }
    }

    private getActionMode(): string {
        return this.includingFollowingModeForm.get('actionMode').value;
    }

    public onConfirm() {
        const includeFollowing = this.getActionMode() === 'this-and-following';
        this.close();
        this.confirmed(includeFollowing);
    }

    public onClose() {
        this.close();
    }

    public get confirmDisabled(): boolean {
        return this.showRadioButtonsToChooseWhetherIncludeFollowing && !this.getActionMode();
    }

    public get showRadioButtonsToChooseWhetherIncludeFollowing(): boolean {
        return this.event.isRecurring;
    }

    public get showChangedFields(): boolean {
        return this.event.changedFields && this.event.changedFields.length > 0;
    }
}
